function getFdrStyle(fdrRating) {
    let fdrClass = '';
    switch(fdrRating) {
        case 'No Rating':
            break;
        case 'Moderate':
            fdrClass = 'fdr-style-moderate';
            break;
        case 'High':
            fdrClass = 'fdr-style-high';
            break;
        case 'Extreme':
            fdrClass = 'fdr-style-extreme';
            break;
        case 'Catastrophic':
            fdrClass = 'fdr-style-catastrophic';
            break;
        default:
            console.error(`Unhandled fdr rating value : ${summaryData.fdr}`);
    }
    return fdrClass;
}

/**
 * Builds all the sub region rows and adds them to the table.
 * NOTE : This should be called AFTER the region row has been added.
 * @param {*} summaryData 
 * @param {*} detailData 
 */
function createSubRegionRows(index, summaryData, detailData, table) {
    let counter = 1;
    // Get the access id for the summary data (used to get all the 'detailed' data)
    const summaryAac = summaryData.aac;

    // Build all the summary data sub-region rows
    summaryData.areas.forEach((subRegion) => {

        // Determine the FDR class to use
        let fdrClass = getFdrStyle(subRegion.fdr);

        const stdSubRowData = [
            // Sub-region name
            subRegion.description,
            // District FBI
            subRegion.fbi,
            // Rating
            `<div class="${fdrClass} full-cell">${subRegion.fdr}</div>`,
            // Sub area Rating >= Extreme
            subRegion.minor_fdr_extreme_flag ?? '<div class="fdr-extreme-no full-cell">No</div>',
            // cHaines
            subRegion.haines_index,
            // TAL
            subRegion.lightning_activity_level,
            // Wind Change Danger Index
            subRegion.wcdi,
            // Max Temp (empty)
            '',
            // Min RH (empty)
            '',
            // Wind dir (empty)
            '',
            // Wind spd (empty)
            '',
            // Wind gust (empty)
            ''
        ]

        const tr = $(`<tr id="${counter}-${index}-sub-region-row-id"></tr>`);
        tr.css({
            'display': 'none'
        })

        stdSubRowData.forEach((col) => {
            tr.append($(`<td><div class="col-style">${col}</div></td>`));
        })

        counter += 1;

        table.append(tr);
    });

    const filtDetailData = detailData.filter(e => e.aac === summaryAac);

    filtDetailData.forEach((subRegion) => {
        const detailSubRowData = [
            subRegion.fuel_type + ' (' + subRegion.coverage + '%)',
            subRegion.fbi,
            'N/A',
            'HI+: ' + subRegion.coverage_fbi_2 + '%',
            'Start: ' + subRegion.start_time_fbi_2,
            'Hrs: ' + subRegion.period_fbi_2,
            'EXT+: ' + subRegion.coverage_fbi_3 + '%',
            'Start: ' + subRegion.start_time_fbi_3,
            'Hrs: ' + subRegion.period_fbi_3,
            'CAT+: ' + subRegion.coverage_fbi_3 + '%',
            'Start: ' + subRegion.start_time_fbi_4,
            'Hrs: ' + subRegion.period_fbi_4
        ];

        const tr = $(`<tr id="${counter}-${index}-sub-region-row-id"></tr>`);
        tr.css({
            'display': 'none'
        })

        detailSubRowData.forEach((col) => {
            tr.append($(`<td><div class="col-style">${col}</div></td>`));
        })

        counter += 1;

        table.append(tr);
    })
}

/**
 * Segments the data based on regions.
 * @param {*} selectedData The day that was selected
 */
export function createRegionRows(tableData, selectedDay, table) {
    
    // Create the table head
    const tHead = $(`<tr></tr>`);
    const subTHead = $(`<tr></tr>`);

    const regRows = [
        'Region',
        'District FBI',
        'Rating',
        'Sub Area Rating ≥ Extreme',
        'cHaines',
        'TAL',
        'Wind Change Danger Index',
        'Max Temp (°C)',
        'Min RH (%)',
    ];

    regRows.forEach((row) => {
        const th = $(`<th class="ui-table-heading" rowspan="2">${row}</th>`);
        tHead.append(th);
    });

    // Now the very annoying header
    const windKmh = $(`<th class="ui-table-heading" colspan="3">` + 
            `Wind (km/h)` + 
        `</th>`);
    tHead.append(windKmh);

    const windKmhSubRows = [
        'Dir', 'Spd', 'Gust'
    ];

    windKmhSubRows.forEach((row) => {
        subTHead.append($(`<th class="ui-table-heading">${row}</th>`))
    });

    // Create the table body
    const tBody = $(`<tbody></tbody>`);

    // Iterate through all the summary data
    for(let i = 0; i < tableData.summary[selectedDay].data.length; i++) {
        const summaryData = tableData.summary[selectedDay].data[i];
        const weatherData = tableData.weather[selectedDay].data[i];
        const detailData = tableData.detailed[selectedDay].data;

        // Create the dropdown button for showing / hiding the sub-region rows
        const subRegionBtn = $(`<button class="sub-region-button-style" style="margin-right:5%;margin-left:20%;"><i id="${i}-sub-region-btn-id" class="bi bi-chevron-down"></i></button>`);
        subRegionBtn.on("click", function() {
            $(`#${i}-sub-region-btn-id`).toggleClass("bi-chevron-down bi-chevron-up")

            const selectedRows = $(`[id$='-${i}-sub-region-row-id']`);
            
            if($(`#${i}-sub-region-btn-id`).hasClass('bi-chevron-up')) {
                // Show the selected rows
                selectedRows.css({
                    'display': 'table-row'
                });
            } else {
                selectedRows.css({
                    'display': 'none'
                })
            }
            
        });

        // Create the region row
        const regionRow = $(`<tr></tr>`);

        // Region
        const firstCol = $(`<td></td>`);
        const firstColContainer = $(`<div class="first-col-style"></div>`)
        firstColContainer.append(subRegionBtn);
        firstColContainer.append($(`<div>${summaryData.description}</div>`))
        firstCol.append(firstColContainer);

        regionRow.append(firstCol);

        // Compute the sub area rating >= Extreme
        let subAreaRatingExtreme = false;
        if(summaryData.fire_danger_rating_max_in_subareas == 'Extreme' ||
            summaryData.fire_danger_rating_max_in_subareas == 'Catastrophic') {
                subAreaRatingExtreme = true;
        }

        // Determine the FDR class to use
        let fdrClass = getFdrStyle(summaryData.fdr);
        

        // Since all the other cols are similar, we can just write them using a loop
        const stdColData = [
            // District FBI
            summaryData.fbi,
            // Rating
            `<div class="${fdrClass} full-cell">${summaryData.fdr}</div>`,
            // Sub Area Rating >= Extreme
            subAreaRatingExtreme ? `<div class="sub-area-fdr-max-yes full-cell">Yes</div>` : 
                    `<div class="sub-area-fdr-max-no full-cell">No</div>`,
            // cHaines
            summaryData.haines_index,
            // TAL
            summaryData.lightning_activity_level,
            // Wind Change Danger Index
            summaryData.wcdi,
            // Max Temp
            `${weatherData.air_temperature_maximum_50_percentile} - ` +
                `${weatherData.air_temperature_maximum_90_percentile}`,
            // Min RH
            `${weatherData.relative_humidity_minimum_10_percentile} - ` + 
                `${weatherData.relative_humidity_minimum_50_percentile}`,
            // Wind Dir
            `${weatherData.wind_direction_at_elevation_1} - ` +
                `${weatherData.wind_direction_at_elevation_2}`,
            // Wind Spd
            `${weatherData.wind_speed_at_elevation_1_50_percentile} - ` +
                `${weatherData.wind_speed_at_elevation_1_90_percentile}`,
            // Wind Gust
            `${weatherData.wind_gust_at_elevation_1_50_percentile} - ` +
                `${weatherData.wind_gust_at_elevation_1_90_percentile}`
        ];

        stdColData.forEach((col) => {
            regionRow.append($(`<td><div class="col-style">${col}</div></td>`));
        });

        tBody.append(regionRow);

        // Create the sub-region rows
        createSubRegionRows(i, summaryData, detailData, tBody);

    }

    table.append(tHead);
    table.append(subTHead);
    table.append(tBody);

}